import axiosInstance from 'src/utils/axiosInstance';
import UrlConstants from 'src/constants/urlConstants';

const UPDATE_AGENCY_PATH = UrlConstants().AGENCY_PATH;
const ADD_NEW_AGENCY_PATH = UrlConstants().ADD_NEW_AGENCY_PATH;
const AGENCY_CARRIERS_PATH = UrlConstants().AGENCY_CARRIERS_PATH;

export const createAgency = params =>
  axiosInstance.post(
    ADD_NEW_AGENCY_PATH,
    { ...params },
    {
      withCredentials: true,
    },
  );

export const updateAgency = agencyData =>
  axiosInstance.patch(
    `${UPDATE_AGENCY_PATH}${agencyData.agency.id}.json`,
    agencyData,
    {
      withCredentials: true,
    },
  );

export const getAgencyCarriers = () =>
  axiosInstance.get(`${AGENCY_CARRIERS_PATH}.json`, {
    withCredentials: true,
  });
